import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Plan from "./component";

import {
  getAssessmentAttemptByUserId,
  getInsightfulContent,
} from "../dashboard/actions";
import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import {
  getAbTest,
  getAssessmentResultByAssessmentAttemptId,
  getPlans,
} from "../plan/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getPlansConnect: getPlans,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      getAbTestConnect: getAbTest,
      getInsightfulContentConnect: getInsightfulContent,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Plan);
